export type ActivationPageViewContext = {
    isAssetOwner: boolean;
};

const contextByActivationId = new Map<string, ActivationPageViewContext>();

export const setActivationPageViewContext = (activationId: string, context: ActivationPageViewContext): void => {
    contextByActivationId.set(activationId, context);
};

/** Returns and clears the stashed context for this activation id (if any). */
export const takeActivationPageViewContext = (activationId: string): ActivationPageViewContext | undefined => {
    const context = contextByActivationId.get(activationId);
    contextByActivationId.delete(activationId);
    return context;
};

export const clearActivationPageViewContext = (): void => {
    contextByActivationId.clear();
};
